import { render, staticRenderFns } from "./LinkChooserDialog.vue?vue&type=template&id=18fd8226&"
import script from "./LinkChooserDialog.vue?vue&type=script&lang=ts&"
export * from "./LinkChooserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LinkChooserDialog.vue?vue&type=style&index=0&id=18fd8226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports